import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUSES = ["new", "replied", "closed"];

export default function AdminContacts() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    await api.put(`/admin/contacts/${id}`, { status });
    toast.success("Status updated");
    load();
  };

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-serif text-4xl text-espresso">Contact Messages</h1>
      <p className="text-espresso/60 mt-2">{items.length} total</p>

      <div className="mt-8 space-y-4">
        {items.length === 0 && <p className="text-espresso/50">No messages yet.</p>}
        {items.map((it) => (
          <div key={it.id} className="bg-taupe rounded-2xl p-6" data-testid={`contact-row-${it.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div>
                <h3 className="font-serif text-xl text-espresso">{it.full_name} {it.business_name && <span className="text-espresso/50 text-base">· {it.business_name}</span>}</h3>
                <p className="text-espresso/70 text-sm">{it.email} · prefers {it.preferred_contact}</p>
                {it.service_category && <p className="text-champagne text-sm mt-1">{it.service_category}</p>}
                <p className="text-espresso/50 text-xs mt-1">{new Date(it.created_at).toLocaleString()}</p>
              </div>
              <select value={it.status} onChange={(e) => setStatus(it.id, e.target.value)} data-testid={`contact-status-${it.id}`}
                className="bg-ivory border border-champagne/40 rounded-lg px-3 py-2 text-sm text-espresso">
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <p className="text-espresso/80 text-sm mt-4 border-t border-champagne/30 pt-4">{it.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
